import React from 'react';
import PropTypes from 'prop-types';

import QuestionText from '../QuestionText';
import { getTranslation } from '../../i18n';
import { questionType, questionTypeValues, responseOptionType } from '../../constants/types';

import styles from './selectionQuestion.module.css';
import sharedStyles from '../../styles/shared';

const SelectionQuestion = ({
  orderNum, question, onChange, errorState, lang, responseOptions, answer, translate: t
}) => {
  const isRadioChecked = (value) => value === answer;
  const isCheckboxChecked = (value) => (answer ? answer.includes(value) : false);

  const handleRadioChange = (event) => {
    onChange(event.target.name, Number(event.target.value));
  };
  const handleCheckboxChange = (event) => {
    const value = Number(event.target.value);
    const removeAnswer = () => answer.filter((a) => a !== value);
    const addAnswer = () => (answer ? [value, ...answer] : [value]);
    const selectedValues = isCheckboxChecked(value) ? removeAnswer() : addAnswer();
    onChange(event.target.name, selectedValues.length > 0 ? selectedValues : null);
  };

  const isRadioGroup = question.type === questionTypeValues.RADIO_BUTTON_GROUP;
  const questionRole = isRadioGroup ? 'radiogroup' : 'group';
  const inputType = isRadioGroup ? 'radio' : 'checkbox';
  const questionElementId = `question_${question.id}`;
  const errorId = `err_${question.id}`;

  return (
    <div
      className={`${sharedStyles.row} ${sharedStyles.questionRow}`}
      role={questionRole}
      aria-labelledby={questionElementId}
      aria-required={question.required || undefined}
      aria-invalid={errorState && question.required ? 'true' : undefined}
      aria-describedby={errorState ? errorId : undefined}
    >
      <QuestionText
        id={questionElementId}
        errorId={errorId}
        showError={errorState && question.required}
        question={question}
        orderNum={orderNum}
        lang={lang}
        translate={t}
      />
      <div className={styles.responseOptions}>
        {responseOptions.map((responseOption) => {
          const { value, text } = responseOption;
          const questionId = question.id;
          const optionId = `${questionId}_${responseOption.id}`;
          const checked = isRadioGroup ? isRadioChecked(value) : isCheckboxChecked(value);
          const handleChange = isRadioGroup ? handleRadioChange : handleCheckboxChange;
          const labelText = getTranslation(text, lang);

          return (
            <div key={optionId} className={`form__item ${styles.responseOption}`}>
              <input
                type={inputType}
                name={questionId}
                id={optionId}
                value={value}
                checked={checked}
                onChange={handleChange}
                aria-describedby={errorState ? errorId : undefined}
              />
              <label htmlFor={optionId}>{labelText}</label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const {
  number, func, bool, string, arrayOf, oneOfType
} = PropTypes;
SelectionQuestion.propTypes = {
  orderNum: number.isRequired,
  question: questionType.isRequired,
  onChange: func.isRequired,
  errorState: bool,
  lang: string.isRequired,
  responseOptions: arrayOf(responseOptionType).isRequired,
  answer: oneOfType([arrayOf(number), number]),
  translate: func.isRequired
};

SelectionQuestion.defaultProps = {
  answer: null,
  errorState: false
};

export default SelectionQuestion;
